/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { OAuthClientUIConfiguration } from './OAuthClientUIConfiguration';
import {
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationFromJSONTyped,
    OAuthClientUIConfigurationToJSON,
} from './OAuthClientUIConfiguration';

/**
 * 
 * @export
 * @interface GetOauth2UiConfiguration200Response
 */
export interface GetOauth2UiConfiguration200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetOauth2UiConfiguration200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetOauth2UiConfiguration200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {OAuthClientUIConfiguration}
     * @memberof GetOauth2UiConfiguration200Response
     */
    result: OAuthClientUIConfiguration;
}

/**
 * Check if a given object implements the GetOauth2UiConfiguration200Response interface.
 */
export function instanceOfGetOauth2UiConfiguration200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetOauth2UiConfiguration200ResponseFromJSON(json: any): GetOauth2UiConfiguration200Response {
    return GetOauth2UiConfiguration200ResponseFromJSONTyped(json, false);
}

export function GetOauth2UiConfiguration200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOauth2UiConfiguration200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': OAuthClientUIConfigurationFromJSON(json['result']),
    };
}

export function GetOauth2UiConfiguration200ResponseToJSON(value?: GetOauth2UiConfiguration200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': OAuthClientUIConfigurationToJSON(value.result),
    };
}

